module.exports = __webpack_public_path__ + "static/media/1017087.da1b0590.png";